import actionType from '../types/changePassword.type';
import { Dispatch } from 'redux';
import URLConstants from '../constants/url.constants';
import * as services from '../services/services';
import { defaultStateDispatcher } from './common.action';

export const changePasswordStart = () => {
	return {
		type: actionType.CHANGE_PASSWORD_START
	};
};

export const changePasswordSuccess = () => {
	return {
		type: actionType.CHANGE_PASSWORD_SUCCESS
	};
};

export const changePasswordFailed = (error: string) => {
	return {
		type: actionType.CHANGE_PASSWORD_FAILED,
		payload: error
	};
};

export const changePassword = (isAdmin: boolean, data: any) => {
	return (dispatch: Dispatch) => {
		dispatch(changePasswordStart());
		let passwordData: any;
		let url = URLConstants.ChangeUserPassword;
		if (isAdmin) {
			url = URLConstants.ChangePassword;
			passwordData = {
				Id: Number(data.UserId),
				NewPassword: data.NewPassword,
			}
		}
		else {
			passwordData = {
				Id: Number(data.UserId),
				OldPassword: data.OldPassword,
				NewPassword: data.NewPassword,
			}
		}
		services.post(url, passwordData)
			.then((response: any) => {
				if (response.data === false)
					dispatch(changePasswordFailed('Failed'));
				else if (response.data === true)
					dispatch(changePasswordSuccess());
			})
			.catch(err => {
				dispatch(changePasswordFailed(err));
			});
	};
};

export const resetChangePasswordState = () => {
	return (dispatch: Dispatch) => {
		dispatch(defaultStateDispatcher());
	};
};